// OTP Service — routes through PHP backend (same API as everything else)
// No longer needs a separate FastAPI/Python proxy

function getApiBaseUrl() {
  let base = (window.APP_CONFIG && window.APP_CONFIG.apiUrl)
    ? window.APP_CONFIG.apiUrl
    : '/api/';
  base = base.replace(/\/$/, '');
  if (base.startsWith('/')) {
    base = window.location.origin + base;
  }
  return base;
}

class OtpService {
  async sendOtp(phone, countryCode) {
    try {
      const base = getApiBaseUrl();
      const url  = new URL(base + '/index.php');
      url.searchParams.set('action', 'sendOtp');
      url.searchParams.set('data', JSON.stringify({ phone, country_code: countryCode }));

      const response = await fetch(url.toString(), { method: 'GET', redirect: 'follow' });
      const text     = await response.text();
      let data       = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch {
          return {
            success: false,
            error: response.ok
              ? 'Invalid response from OTP service'
              : `OTP service error (${response.status})`,
          };
        }
      } else if (!response.ok) {
        return { success: false, error: `OTP service error (${response.status})` };
      }

      if (data.success && data.transaction_id) {
        return {
          success:        true,
          transaction_id: data.transaction_id,
          expires_at:     data.expires_at,
          message:        data.message || 'OTP sent successfully',
        };
      }
      return { success: false, error: data.error || 'Failed to send OTP' };
    } catch (error) {
      console.error('OTP Send Error:', error);
      return { success: false, error: error.message || 'Network error while sending OTP' };
    }
  }

  async verifyOtp(transactionId, otp) {
    try {
      const base = getApiBaseUrl();
      const url  = new URL(base + '/index.php');
      url.searchParams.set('action', 'verifyOtp');
      url.searchParams.set('data', JSON.stringify({ transaction_id: transactionId, otp }));

      const response = await fetch(url.toString(), { method: 'GET', redirect: 'follow' });
      const text     = await response.text();
      let data       = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch {
          return {
            success: false,
            verified: false,
            error: response.ok
              ? 'Invalid response from OTP service'
              : `OTP service error (${response.status})`,
          };
        }
      } else if (!response.ok) {
        return { success: false, verified: false, error: `OTP service error (${response.status})` };
      }

      if (data.success && (data.verified || data.status === 'verified')) {
        return { success: true, verified: true, message: data.message || 'OTP verified successfully' };
      }
      return { success: false, verified: false, error: data.error || 'Invalid OTP' };
    } catch (error) {
      console.error('OTP Verify Error:', error);
      return { success: false, verified: false, error: error.message || 'Network error while verifying OTP' };
    }
  }
}

export const otpService = new OtpService();
export default otpService;
